module.exports = __webpack_public_path__ + "static/img/role.2f3e9a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/zxrx/role.png
// module id = kub4
// module chunks = 7